import { assert } from '../Utility/assert';
import { IMessagingClient } from './IMessagingClient';
import { ILogRelay } from '../Logging/ILogRelay';
import { IPushReceiver } from './IPushReceiver';
import { IRpcHost } from './IRpcHost';

let _messagingClient: IMessagingClient | undefined = undefined;
let _logRelay: ILogRelay | undefined = undefined;
let _pushReceiver: IPushReceiver | undefined = undefined;
let _rpcHost: IRpcHost | undefined = undefined;

export function setMessagingClient(client: IMessagingClient): void {
    assert(_messagingClient === undefined, 'The messaging client is already defined.');
    _messagingClient = client;
}

export function messagingClient(): IMessagingClient {
    assert(_messagingClient !== undefined, 'The messaging client has not been defined.');
    return _messagingClient;
}

export function setLogRelay(relay: ILogRelay): void {
    assert(_logRelay === undefined, 'The log relay is already defined.');
    _logRelay = relay;
}

export function logRelay(): ILogRelay {
    assert(_logRelay !== undefined, 'The log relay has not been defined.');
    return _logRelay;
}

export function setPushReceiver(receiver: IPushReceiver): void {
    assert(_pushReceiver === undefined, 'The push receiver is already defined.');
    _pushReceiver = receiver;
}

export function pushReceiver(): IPushReceiver {
    assert(_pushReceiver !== undefined, 'The push receiver has not been defined.');
    return _pushReceiver;
}

export function setRpcHost(host: IRpcHost): void {
    assert(_rpcHost === undefined, 'The RPC host is already defined.');
    _rpcHost = host;
}

export function rpcHost(): IRpcHost {
    assert(_rpcHost !== undefined, 'The RPC host has not been defined.');
    return _rpcHost;
}
